module.exports = __webpack_public_path__ + "img/inge-v9-char-3.8e14ba81.png";